import { useNavigate } from "react-router-dom";
import { useGetUser } from "../auth/useGetUser";
import { useEffect } from "react";
import SpinnerFullPage from "../../ui/SpinnerFullPage";

function RequireHasInfo({ children }: { children: React.ReactNode }) {
  const { user, isPending } = useGetUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (isPending) return;
    if (!user?.has_info) {
      navigate("/questions", { replace: true });
    }
  }, [isPending, user, navigate]);

  if (isPending) return <SpinnerFullPage />;
  if (!user?.has_info) return null;

  return <>{children}</>;
}

export default RequireHasInfo;
